<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click.native="close()">
        <v-icon>close</v-icon>
      </v-btn>
      <h2>How to Navigate Sensor History</h2>
    </v-toolbar>
    <div style="padding: 20px">
        
        You can view the historical sensor data either graphically or in tabular form.
        <p/>
        To view graphically click on the HISTORY (CHART) tab at the top.
        <p/>
        By default, the graph will show the last 200 readings. The last reading date will also be shown. If the sensor has not been active lately, the last reading may be old.
        <p/>
        You can select a date range by clicking at the date selector at the top left. You can select predefined ranges commonly used, or select exact date and time ranges.
        <p/>
        You can hide graphs you are not interested in by clicking on teh correspond legend. Clicking it again will show the graph for that reading again.
        <p/>
        You can zoom in to part of the date range by clicking and dragging with left mouse button over the graph, from left to right, forming a box. Clicking the right button will return the graph to full range.
        <p/>
        When hovering the mouse pointer over each graph, a dot will be shown where actual readings exist, Clicking on that dot will pop up the reading taken at that time.
      </div>
    
  </v-card>
</template>
<script>
export default {
  props: ['show2'],
  methods: {
    close() {
      this.$emit('update:show2', false)
    }
  }
}
</script>